import { snakeCase as snakeCaseString } from "utilities/strings";

export function safeParse(value: Nullable<string>) {
  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
}
export function snakeCase(object: Record<string, any>): Record<string, any> {
  if (Array.isArray(object)) {
    return object.map((item) =>
      typeof item === "object" && item !== null ? snakeCase(item) : item
    );
  }

  return Object.keys(object).reduce(
    (memo, key): Record<string, any> => ({
      ...memo,
      [snakeCaseString(key)]:
        typeof object[key] === "object" && object[key] !== null
          ? snakeCase(object[key])
          : object[key],
    }),
    {}
  );
}
